import React from 'react';

import { useIntl, defineMessages } from 'react-intl';
import { Button } from 'semantic-ui-react';
import { Icon, UniversalLink } from '@plone/volto/components';
import PlayStoreSVG from 'unimc-theme/icons/download_google_play.svg';
import AppleStoreSVG from 'unimc-theme/icons/download_appstore.svg';

import './footerMainRight.less';

const messages = defineMessages({
  download_play_store: {
    id: 'Download from Play store',
    defaultMessage: 'Download from Play store',
  },
  download_app_store: {
    id: 'Download from App store',
    defaultMessage: 'Download from App store',
  },
});
const FooterMainRight = () => {
  const intl = useIntl();

  return (
    <div className="footer-main-right">
      <div className="title">MY UNIMC</div>

      <Button
        inverted
        as={UniversalLink}
        href="https://apps.apple.com/it/app/myunimc/id1052892761"
        title={intl.formatMessage(messages.download_app_store)}
      >
        <Icon name={AppleStoreSVG} size="28px" color="white" />
      </Button>

      <Button
        inverted
        as={UniversalLink}
        href="https://play.google.com/store/apps/details?id=it.unimc.my"
        title={intl.formatMessage(messages.download_play_store)}
      >
        <Icon name={PlayStoreSVG} size="28px" color="white" />
      </Button>
    </div>
  );
};

export default FooterMainRight;
